package blazern.lexisoup

import org.koin.dsl.module

internal actual fun platformModule() = module {
    // Nothing yet
}
